import axios from 'axios';

export const renameContactGroups = (projectId, data) =>
	axios.put(`/api/projects/${projectId}/rename-contact-group`, data);

export const updateContactGroupSettings = (projectId, groupId, data) =>
	axios.put(`/api/projects/${projectId}/contact-groups/${groupId}/settings`, data);

export const resyncContactGroups = (projectId, contactGroupId) =>
	axios.put(`/api/projects/${projectId}/contact-groups/resyncWithSib/${contactGroupId}`);

export const resyncKudosityContactGroups = (projectId, contactGroupId, activeMonths = 18) =>
	axios.put(`/api/projects/${projectId}/contact-groups/kudosity/resync/${contactGroupId}`, { activeMonths });

export const checkKudosityProcessingStatus = (projectId, listId) =>
	axios.get(`/api/projects/${projectId}/contact-groups/kudosity/check-processing-status-of-import/${listId}`);

export const resyncCCContactGroups = (projectId, contactGroupId, activeMonths = 18) =>
	axios.put(`/api/projects/${projectId}/contact-groups/cc/resync/${contactGroupId}`, { activeMonths });

export const checkCCProcessingStatus = (projectId, activityId) =>
	axios.get(`/api/projects/${projectId}/contact-groups/cc/check-processing-status-of-import/${activityId}`);

export const fetchContactGroupsList = (projectId) =>
	axios.get(`/api/projects/${projectId}/contact-groups-list`);
